import { store } from "@3gaam/capp/src/store";
import {
  setIsLoggedInAction,
  setIsTokenValidAction,
} from "@3gaam/capp/src/store/auth";
import Notification from "@3gaam/shared/components/general/notification";
import { b64ToUtf8 } from "@3gaam/shared/utils/base64";
import { localStorageGet } from "@3gaam/shared/utils/localStorage";
import axios from "axios";

let version = process.env.REACT_APP_VERSION;

let onAxiosRequest = () => {
  axios.interceptors.request.use(
    (config) => {
      config.timeout = 20000;
      //@ts-ignore
      config.headers.common.Accept = "application/json";
      //@ts-ignore
      config.headers.common["Content-Type"] = "application/json";
      const AccessToken = localStorageGet("auth")?.AccessToken;
      if (AccessToken) {
        //@ts-ignore
        config.headers.Authorization = AccessToken;
      }
      //@ts-ignore
      config.headers.common["Current-Client-Type"] = "PANEL";
      //@ts-ignore
      config.headers.common["Current-Client-Version"] = version;
      config.withCredentials = true;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};

let onAxiosResponse = (handleShowUpdateModal) => {
  axios.interceptors.response.use(
    (response) => {
      const versionCommand =
        response.headers["client-version-command"]?.toLowerCase();
      const latestVersion = response.headers["latest-client-version"];
      const clientMessage =
        b64ToUtf8(response?.headers["latest-client-message"]) ||
        "نسخه جدید نرم‌افزار منتشر شده";
      const latestLocalVersion = localStorage.getItem("version");
      let upgradeModalShownBefore = !!(
        latestLocalVersion && latestVersion === latestLocalVersion
      );
      if (versionCommand === "upgrade" && !upgradeModalShownBefore) {
        handleShowUpdateModal({
          ignorable: true,
          message: clientMessage,
          latestVersion,
        });
        // prevent to show optional update modal again
        localStorage.setItem("version", latestVersion);
      }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem("auth");
        store.dispatch(setIsLoggedInAction(false));
        store.dispatch(setIsTokenValidAction(false));
      } else if (error?.response?.status === 403) {

        const url = error?.response?.config.url as String;
        if(url.endsWith('/MembershipCommand/Identity')){
          localStorage.removeItem("auth");
          store.dispatch(setIsLoggedInAction(false));
          store.dispatch(setIsTokenValidAction(false));
        }

        Notification({
          type: "danger",
          message: "شما مجوزهای مورد نیاز را ندارید",
        });
      } else if (
        error?.response?.status === 412 &&
        error?.response?.data?.Type === "ExpiredClientVersion"
      ) {
        let message =
          error?.response?.data?.UpgradeMessage ||
          b64ToUtf8(error?.response?.headers["latest-client-message"]) ||
          "نسخه فعلی نرم‌افزار منقضی شده";
        handleShowUpdateModal({ ignorable: false, message });
        return Promise.reject(false);
      } else if (error?.response?.status === 400) {
        return Promise.reject(error);
      } else if (error?.response?.status === 500) {
        Notification({
          type: "danger",
          message: "اشکال در برقراری ارتباط با سرور",
        });
      }
      return Promise.reject(error?.response);
    },
  );
};

export { onAxiosRequest, onAxiosResponse };
